import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ViewForm } from '../patient_profile/forms_list';
import { DialogActions } from '@mui/material';
import { DownloadFormButton } from './downloadformbutton';


const PatientFormDialog = ({ formId, buttonText = 'View', dialogTitle = 'Patient Form' }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button variant="outlined" size="small" onClick={handleOpen}>{buttonText}</Button>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <DialogTitle sx={{ display: 'flex', fontWeight:"bold", justifyContent: 'space-between', alignItems: 'center' }}>
          {dialogTitle}
          <IconButton onClick={handleClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc'}}>
          <ViewForm form={{ id: formId }} />
        </DialogContent>
        <DialogActions>
          <DownloadFormButton form={{ id: formId }} />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PatientFormDialog;
